import React, { Component } from 'react';

import LayoutWithHeader from '../../component/layoutWithHeader';
import Admin from './model/admin';
import { getTenantInfo } from '../../api';
import PageNotFound from '../../component/404';
import isosLogo from '../../assets/img/ISOS_banner_v4.png';
import {checkdomain} from "../../utils/utils";

class Login extends Component{
  constructor(props) {
    super(props);
    this.state = {
      admin: '',
      logo: '',
      tenantname: '',
      pageNotFound: false,
      headlineColor: ''
    };
  }

  componentWillMount() {
    let tenantname = location.hostname.split('.')[0].split('-')[0];
    if (checkdomain(tenantname)) {
      return this.setState({
        admin: "isos"
      });
    }
    getTenantInfo({}, {headers: {'tenantname': tenantname}})
      .then(res => {
        this.setState({
          admin: res.data.companyName,
          tenantname: res.data.name,
          logo: res.data.logo,
          headlineColor: res.data.headlineColor
        })
      })
      .catch(err=>{
        if (err.message && err.message === "The tenant was not found.") {
          this.setState({pageNotFound: true});
        }
        console.log(err);
      });
  }

  render() {
    let { admin, tenantname, logo, headlineColor } = this.state;
    if (admin === "isos") logo = isosLogo;
    if (this.state.pageNotFound) {
      return <PageNotFound />;
    }

    return (
      <LayoutWithHeader logo={logo}>
        <Admin admin={admin} tenantname={tenantname} headlineColor={headlineColor} />
      </LayoutWithHeader>
    );
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/container/login/index.js